import React from "react";
import { getTagColorClass } from "./virbrixliteConfigUtils";

const VirbrixliteTagPill = ({ tag }) => (
  <span className={`lite-tag ${getTagColorClass(tag)}`}>{tag}</span>
);

export default VirbrixliteTagPill;
